import React from 'react';

// Generated from the LegalApp design canvas.
export default function CtaCaseFile({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-cta-iso" viewBox="-150.3 -52.0 272.9 182.0" role="img" aria-label="Illustration: a completed case file" style={style}>
    <polygon points="103.9,60.0 0.0,120.0 0.0,108.0 103.9,48.0" fill="#101F42" />
    <polygon points="-103.9,60.0 0.0,120.0 0.0,108.0 -103.9,48.0" fill="#182A50" />
    <polygon points="0.0,-12.0 103.9,48.0 0.0,108.0 -103.9,48.0" fill="#22345E" />
    <polygon points="69.3,50.0 15.6,81.0 15.6,78.0 69.3,47.0" fill="#BCD1F8" />
    <polygon points="-52.0,42.0 15.6,81.0 15.6,78.0 -52.0,39.0" fill="#E4EDFD" />
    <polygon points="1.7,8.0 69.3,47.0 15.6,78.0 -52.0,39.0" fill="#FFFFFF" />
    <polygon points="64.1,48.0 8.7,80.0 8.7,77.0 64.1,45.0" fill="#DCE6FB" />
    <polygon points="-60.6,40.0 8.7,80.0 8.7,77.0 -60.6,37.0" fill="#F1F5FE" />
    <polygon points="-5.2,5.0 64.1,45.0 8.7,77.0 -60.6,37.0" fill="#FFFFFF" />
    <polygon points="64.1,47.0 6.9,80.0 6.9,72.0 64.1,39.0" fill="#1A4DB8" />
    <polygon points="-65.8,38.0 6.9,80.0 6.9,72.0 -65.8,30.0" fill="#2563DE" />
    <polygon points="-8.7,-3.0 64.1,39.0 6.9,72.0 -65.8,30.0" fill="#4C81EC" />
    <polygon points="65.0,40.5 58.9,44.0 58.9,36.0 65.0,32.5" fill="#1A4DB8" />
    <polygon points="39.8,33.0 58.9,44.0 58.9,36.0 39.8,25.0" fill="#2563DE" />
    <polygon points="45.9,21.5 65.0,32.5 58.9,36.0 39.8,25.0" fill="#4C81EC" />
    <polygon points="-8.7,11.0 27.7,32.0 -5.2,51.0 -41.6,30.0" fill="#FFFFFF" />
    <text transform="matrix(0.8660 -0.5 0.8660 0.5 -26.8 34.5)" className="lp-iso-label" fill="#0B1B3F">
      {"CASE"}
    </text>
    <text transform="matrix(0.8660 -0.5 0.8660 0.5 -16.5 40.5)" className="lp-iso-label" fill="#0B1B3F">
      {"FILE"}
    </text>
    <polygon points="13.0,29.5 16.5,31.5 -2.6,42.5 -6.1,40.5" fill="#F2A33A" />
    <g className="lp-iso-badge lp-float-b">
      <circle cx="0.0" cy="-22.0" r="20" fill="#F2A33A" />
      <circle cx="0.0" cy="-22.0" r="20" fill="none" className="lp-iso-badge-ring" />
      <path d="M-8.4 -21.6 L-2.0 -15.2 L9.0 -28.0" className="lp-iso-check" />
    </g>
    <g className="lp-iso-float lp-f2">
      <polygon points="112.6,35.0 103.9,40.0 103.9,30.0 112.6,25.0" fill="#D7861F" />
      <polygon points="95.3,35.0 103.9,40.0 103.9,30.0 95.3,25.0" fill="#F2A33A" />
      <polygon points="103.9,20.0 112.6,25.0 103.9,30.0 95.3,25.0" fill="#FFCB7E" />
    </g>
    <g className="lp-iso-float lp-f1">
      <polygon points="-119.5,21.0 -129.9,27.0 -129.9,15.0 -119.5,9.0" fill="#BCD1F8" />
      <polygon points="-140.3,21.0 -129.9,27.0 -129.9,15.0 -140.3,9.0" fill="#E4EDFD" />
      <polygon points="-129.9,3.0 -119.5,9.0 -129.9,15.0 -140.3,9.0" fill="#FFFFFF" />
    </g>
    </svg>
  );
}
